* {
  box-sizing: border-box;
}

:host {
  --h1-size: calc(22px + var(--dynamic-font-size-changer));
  --h2-size: calc(18px + var(--dynamic-font-size-changer));
  --h3-size: calc(16px + var(--dynamic-font-size-changer));
  --h4-size: calc(12px + var(--dynamic-small-font-size-changer));
  --h5-size: calc(11px + var(--dynamic-small-font-size-changer));
  --h6-size: calc(11px + var(--dynamic-small-font-size-changer));
}

:host {
  display: flex;
  flex-direction: row;
  width: 100%;
}

:host([data-invalid]) {
  .editor {
    border-color: var(--red-layout-300-primary);
  }
}

.textarea-form-field {
  --margin-bottom-wrapper: 0;
}

.editor-wrapper {
  flex: 1;
}

.editor {
  border: 1px solid var(--chart-101-pressed-dividers);
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: var(--white-layout-303-level-2-elevation);
  flex: 1;
  position: relative;
  .error-icon {
    position: absolute;
    right: var(--spacer);
    top: var(--spacer);
    z-index: 9999;
  }
}

.reset-button {
  float: right;
}

.textarea-wrapper {
  padding: calc(2.5 * var(--spacer));
  height: 366px;
}

.preview {
  border: 1px solid var(--chart-101-pressed-dividers);
  border-left: none;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: var(--white-layout-302-level-1-elevation);
  flex: 1;
  height: 368px;
  padding: calc(2.5 * var(--spacer));
  overflow-y: auto;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: var(--font-family);
    color: var(--main-titles-inputs-600);
  }

  h1 {
    font-size: var(--h1-size);
    font-weight: 500;
  }

  h2 {
    font-size: var(--h2-size);
    font-weight: 500;
  }

  h3 {
    font-size: var(--h3-size);
    font-weight: 500;
  }

  h4 {
    font-size: var(--h4-size);
    font-weight: 400;
  }

  h5 {
    font-size: var(--h5-size);
    font-weight: 600;
  }

  h6 {
    font-size: var(--h6-size);
    font-weight: 600;
  }

  p,
  ul,
  ol {
    font-family: var(--font-family-secondary);
    font-size: var(--body-size);
    color: var(--main-titles-inputs-600);
  }

  a {
    pointer-events: none;
    color: var(--blue-layout-400-primary);
    &:focus {
      outline: none;
    }
  }
}

.counter {
  display: flex;
  justify-content: flex-end;
  font-family: var(--font-family-secondary-mono);
  font-size: var(--body-size);
  padding: var(--spacer) 0;
  margin-bottom: var(--spacer);
  color: var(--main-titles-inputs-600);
  &.max-chars-reached {
    color: var(--red-layout-300-primary);
  }
}
